import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

const unwrapData = (result) => {
  const body = result?.data;
  if (body?.success === false) {
    const err = new Error(body?.message || "Request failed");
    err.response = { data: body, status: 422 };
    throw err;
  }
  return body?.data ?? body;
};

function* getWhatsappTemplates() {
  try {
    yield put(actions.setWhatsappTemplatesLoading(true));
    const result = yield call(api.getWhatsappTemplates);
    const data = unwrapData(result);
    const templates = Array.isArray(data?.templates)
      ? data.templates
      : Array.isArray(data)
        ? data
        : [];
    yield put(
      actions.getWhatsappTemplatesSuccess({
        templates,
        meta: data?.meta ?? null,
      })
    );
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to load WhatsApp templates";
    toast.error(message);
    yield put(actions.getWhatsappTemplatesFail(message));
  } finally {
    yield put(actions.setWhatsappTemplatesLoading(false));
  }
}

function* getWhatsappTemplate({ payload: name }) {
  try {
    yield put(actions.setWhatsappTemplatesLoading(true));
    const result = yield call(api.getWhatsappTemplate, name);
    const data = unwrapData(result);
    const template = data?.template || data;
    if (!template?.name) {
      throw new Error("Invalid template response");
    }
    yield put(actions.getWhatsappTemplateSuccess(template));
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to load template";
    toast.error(message);
    yield put(actions.getWhatsappTemplateFail(message));
  } finally {
    yield put(actions.setWhatsappTemplatesLoading(false));
  }
}

function* saveWhatsappTemplate({ payload, action }) {
  try {
    yield put(actions.setWhatsappTemplateSaving(true));
    const result = yield call(
      api.updateWhatsappTemplate,
      payload.name,
      payload.body
    );
    const data = unwrapData(result);
    const template = data?.template || data;
    if (!template?.name) {
      throw new Error("Invalid save response");
    }
    yield put(actions.saveWhatsappTemplateSuccess(template));
    toast.success(result?.data?.message || "Template saved");
    if (typeof action === "function") action();
  } catch (error) {
    const responseData = error?.response?.data;
    const message =
      responseData?.message || error?.message || "Failed to save template";
    const validationErrors = responseData?.errors || null;
    toast.error(message);
    yield put(actions.saveWhatsappTemplateFail(message, validationErrors));
  } finally {
    yield put(actions.setWhatsappTemplateSaving(false));
  }
}

export default function* WhatsappTemplatesSaga() {
  yield takeLatest(
    Types.GET_WHATSAPP_TEMPLATES_REQUEST,
    getWhatsappTemplates
  );
  yield takeLatest(Types.GET_WHATSAPP_TEMPLATE_REQUEST, getWhatsappTemplate);
  yield takeLatest(Types.SAVE_WHATSAPP_TEMPLATE_REQUEST, saveWhatsappTemplate);
}
